<template>
  <div class="system-overview">
    <div class="row row u-justify-content-center">
      <div class="col-12 pt-0">
        <BackButton :go-back="goBack"></BackButton>
        <div class="system-overview__wrapper">
          <span class="system-overview__label u-display-block u-text-transform-uppercase">{{ $t('configurator.results.your_selected_system') }}</span>
          <h2>{{name}}</h2>
          <p>
            <span v-if="classic">{{ $t('system.classic.description', {icon: ''}) }}</span>
            <span v-else-if="view">{{ $t('system.view.description', {icon: ''}) }}</span>
            <span v-else-if="tView">{{ $t('system.t_view.description', {icon: ''}) }}</span>
            <span><i class="icon-info" @click="openAmbientConditions"></i></span>
          </p>
          <AmbientConditions
            :show-ambient-conditions="showAmbientConditions"
            :close-ambient-conditions="closeAmbientConditions"
          ></AmbientConditions>
        </div>
        <div class="system-overview__wrapper">
          <div v-if="coldroomSelected && coldroomSelected && coldroomSystemSelected && width && height">
            <div class="results__label u-font-weight-700 u-text-transform-uppercase">{{ $t('configurator.results.your_input') }}</div>
            <table class="system_resume">
              <tr>
                <td>{{ $t('configurator.dimensions.max_width') }}:</td>
                <th>{{ width }}</th>
              </tr>
              <tr>
                <td>{{ $t('configurator.dimensions.max_height') }}:</td>
                <th>{{ height }}</th>
              </tr>
              <tr>
                <td>{{ $t('configurator.colors.label') }}:</td>
                <th>{{ selectedColor }}</th>
              </tr>
              <tr>
                <td>{{ $t('configurator.shelvings.label') }}:</td>
                <th>{{ shelves }}</th>
              </tr>
            </table>
          </div>
          <img v-if="classic" src="../assets/images/system_classic.jpg">
          <img v-else-if="view" src="../assets/images/system_view.jpg">
          <img v-else-if="tView" src="../assets/images/system_t_view.jpg">
          <button v-if="openImage" @click="openImage" class="btn btn--secondary">{{ $t('configurator.results.3d') }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
@import './../sass/main.scss';
.icon-info {
  vertical-align: bottom;
}
</style>

<script>
import AmbientConditions from './AmbientConditions.vue';
import BackButton from "./BackButton.vue";

export default {
  name: "SystemOverview",
  props: [
    'goBack',
    'systemName',
    'systemDescription',
    'openImage',
    'manual',
    'coldroom',
    'coldroomsystem',
    'cutoutwidth',
    'cutoutheight',
    'suggestedheight',
    'color',
    'shelving',
  ],
  components: {
    BackButton,
    AmbientConditions
  },
  data () {
    return {
      description: this.systemDescription,
      showAmbientConditions: false,
      classic: false,
      view: false,
      tView: false,
      systemType: this.manual,
      coldroomSelected: this.coldroom,
      coldroomSystemSelected: this.coldroomsystem,
      width: this.cutoutwidth + " " + "mm",
      height: this.cutoutheight + " " + "mm",
      heighToSuggest: this.suggestedheight,
      selectedColor: this.color,
      shelvings: this.shelving,
      systemNameFromStep: null,
    }
  },
  computed: {
    name: {
      get () {
        if (this.systemName) {
          return this.systemName;
        } else {
          return this.coldroomSystemSelected
        }
      }
    },
    shelves: {
      get () {
        if (this.shelvings) {
          return "Yes";
        } else {
          return "No";
        }
      }
    }
  },
  methods: {
    displayDescription () {
      if (this.name === 'Classic' || this.coldroomSystemSelected === 'classic' || this.systemName === 'classic') {
        this.classic = true;
      } else if (this.name === 'View' || this.coldroomSystemSelected === 'view' || this.systemName === 'view') {
        this.view = true;
      } else {
        this.tView = true;
      }
    },
    openAmbientConditions () {
      this.showAmbientConditions = true;
    },
    closeAmbientConditions () {
      this.showAmbientConditions = false;
    }
  },
  mounted () {
    this.displayDescription();
  }
}
</script>
